<div [ngClass]="{ 'with-floating-button': isWithFloatingButton }">
    <div class="content">
        <page-header *ngIf="isDisplayed" [title]="'admin.workflow.construction.title' | translate" [listeItems]="listeTabItems" [selectedIndex]="selectedIndex" (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>

        <router-outlet></router-outlet>
    </div>
</div>
